import { useState } from 'react'
import cn from 'classnames'
import Select from './select'

import c from './assets/sass/form.module.scss'

const Form = ({
                  categories,
                  selectedCategory,
                  selectedSubscription,
                  onCategoryChange,
                  onSubscriptionChange,
              }) => {
    const [openedSelect, setOpenedSelect] = useState(null)

    const toggleSelect = (name) => {
        setOpenedSelect((prev) => (
            prev === name ? null : name
        ))
    }

    return (
        <div className={c.component}>
            <div className={c.title}>
                Абонемент на {selectedSubscription.services} сеансов
            </div>

            <div className={c.selects}>
                <Select
                    title="Категория"
                    value={selectedCategory.title}
                    isOpened={openedSelect === 'category'}
                    onToggle={() => toggleSelect('category')}
                >
                    <ul className={c.selectList}>
                        {categories.map((category) => (
                            <li
                                className={c.selectItem}
                                key={category.id}
                            >
                                <button
                                    className={cn(
                                        c.selectListButton,
                                        selectedCategory.id === category.id &&
                                        c.selected
                                    )}
                                    onClick={() => {
                                        onCategoryChange(category)
                                        setOpenedSelect(null)
                                    }}
                                >
                                    {category.title}
                                </button>
                            </li>
                        ))}
                    </ul>
                </Select>

                <Select
                    title="Вид услуги"
                    value={selectedSubscription.title}
                    isOpened={openedSelect === 'service'}
                    onToggle={() => toggleSelect('service')}
                >
                    <ul className={c.selectList}>
                        {selectedCategory.items.map((subscription) => (
                            <li
                                className={c.selectItem}
                                key={subscription.id}
                            >
                                <button
                                    className={cn(
                                        c.selectListButton,
                                        selectedSubscription.id === subscription.id &&
                                        c.selected
                                    )}
                                    onClick={() => {
                                        onSubscriptionChange(subscription)
                                        setOpenedSelect(null)
                                    }}
                                >
                                    {subscription.title}
                                </button>
                            </li>
                        ))}
                    </ul>
                </Select>
            </div>
        </div>
    )
}

export default Form
